export default "__VITE_ASSET__D$TgK9NU__"